document.addEventListener('DOMContentLoaded', () => {
    const SCROLL_TOP_BREAKPOINT = 0;

    const body = document.querySelector('body');

    let lastScrollPosition = 0;

    requestAnimationFrame(() => {
        lastScrollPosition = getScrollPosition();

        checkScrollState();
    });

    document.addEventListener('scroll', checkScrollState);

    function checkScrollState() {
        const classes = [
            'not-scrolled',
            'header-scrolled',
            'header-scrolled-up',
        ];

        let classToAdd;
        const currentScrollPosition = getScrollPosition();
        if (currentScrollPosition <= SCROLL_TOP_BREAKPOINT) {
            classToAdd = 'not-scrolled';
        } else if (currentScrollPosition > lastScrollPosition) {
            classToAdd = 'header-scrolled';
        } else {
            classToAdd = 'header-scrolled-up';
        }

        const classesToRemove = classes
            .filter(c => c !== classToAdd);

        lastScrollPosition = currentScrollPosition;

        requestAnimationFrame(() => {
            body.classList.add(classToAdd);
            body.classList.remove(...classesToRemove);
        });
    }

    function getScrollPosition() {
        return window.pageY || document.documentElement.scrollTop;
    }
});


//# sourceMappingURL=header-scroll.js.map
